import React, { useEffect }         from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getBookmarks }             from "../store/bookmarks/actions";
import BookmarkComponent            from "../components/bookmarks/BookmarkComponent";
import { ApplicationState }         from "../store";
import { BookmarkState }            from "../store/bookmarks/types";


interface Props {

}

const BookmarkContainer: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const {bookmarksData} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);

  useEffect(() => {
    dispatch(getBookmarks());
    const bookmarkUpdateTimer = setInterval(() => {
      dispatch(getBookmarks());
    }, 5000);

    //life hack for hovering on image bookmarks
    const el = document.createElement('img');
    document.body.appendChild(el);
    el.classList.add('bkm-thumbnail__hover');
    el.setAttribute('id', 'bkm-thumbnail__hover');
    el.style.display = 'none';

    return () => {
      document.body.removeChild(el);
      clearInterval(bookmarkUpdateTimer);
    };
    ////////////////////////
  }, []);

  return <BookmarkComponent bookmarksData={bookmarksData}/>
};

export default BookmarkContainer;